module.exports = __webpack_public_path__ + "static/otm_consumers-fbb44e6202b738d4b4f88d2351c68124.png";